<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  all({ page, limit, q }) {
    return axios.get(`tipologias?page=${ page }&limit=${ limit }&q=${ q }`, AS.getDefaultHeaders());
  },
  async show(id){
    return await axios.get(`tipologias/${id}`, AS.getDefaultHeaders());
  },

  createOrUpdate(payload) {
    if (payload.id === null) {
      return axios.post('tipologias', payload, AS.getDefaultHeaders());
    }
    return axios.patch(`tipologias/${ payload.id }`, payload, AS.getDefaultHeaders());
  },
  destroy(id){
    return axios.delete(`tipologias/${id}`)
  },

  fetchTypologies(searchField) {
    if (searchField === undefined) {
      return axios.get('tipologias', AS.getDefaultHeaders());
    }
    return axios.post('utils/fetch_typologies', { q: searchField }, AS.getDefaultHeaders());
  },
  fetchTypology(typologyId) {
    return axios.get(`tipologias/${typologyId}`, AS.getDefaultHeaders());
  },
  createTypology(typologyParams) {
    return axios.post('tipologias', { typology: typologyParams }, AS.getDefaultHeaders());
  },
  async fetchEnviromentalStudyTypeRequired(typologyId, technicalParameters) {
    const url = `tipologias/${ typologyId }/estudo_ambiental_exigido`
    const response = await axios.post(url, { technical_parameters: technicalParameters }, AS.getDefaultHeaders())
    return response.data;
  },

};
</script>
